export const getConsumptionCode = (plan_code, attendees) => `${plan_code}$${attendees}`;
export const parseConsumptionCode = (cPlanCode) => {
  const [plan_code, attendees] = cPlanCode.split('$');
  return {
    plan_code,
    attendees,
  };
};
